import React from 'react';
import { Badge, Button, BlockStack, InlineStack, Card, Text } from '@shopify/polaris';

const PricingCard = ({
    title,
    description,
    price,
    features,
    featuredText,
    button,
    frequency
}) => {
    return (
        <div
            style={{
                width: '18rem',
                boxShadow: featuredText ? '0px 0px 15px 4px #CDFEE1' : 'none',
                borderRadius: '.75rem',
                position: 'relative',
                zIndex: '0'
            }}
        >
            {featuredText ? (
                <div style={{ position: 'absolute', top: '-15px', right: '6px', zIndex: '100' }}>
                    <Badge tone="success">
                        {featuredText}
                    </Badge>
                </div>
            ) : null}
            <Card>
                <BlockStack gap="500">
                    <BlockStack gap="200">
                        <Text variant="headingMd" fontWeight="bold" as="h2">
                            {title}
                        </Text>
                        {description ? (
                            <Text tone="subdued" as="p">
                                {description}
                            </Text>
                        ) : null}
                    </BlockStack>

                    <InlineStack gap="200" align="baseline">
                        <Text variant="headingLg" fontWeight="bold" as="h3">
                            {price}
                        </Text>
                        <Text tone="subdued">
                            / {frequency}
                        </Text>
                    </InlineStack>

                    <BlockStack gap="200">
                        {features?.map((feature, id) => (
                            <Text tone="subdued" key={id}>
                                {feature}
                            </Text>
                        ))}
                    </BlockStack>

                    <InlineStack align="end">
                        <Button disabled={button.disabled} {...button.props}>{button.content}</Button>
                    </InlineStack>
                </BlockStack>
            </Card>
        </div>
    );
};

export default PricingCard;